export const C = {
  primary:       '#F5A623',
  primaryDark:   '#E8951D',
  primaryDeep:   '#C97B10',
  primaryLight:  '#FFF3DC',
  primaryBg:     '#FFF8F0',
  sidebar:       '#1C1407',
  sidebarHover:  '#2A1E0A',
  sidebarActive: 'rgba(245,166,35,0.13)',
  sidebarBorder: 'rgba(245,166,35,0.15)',
  white:         '#FFFFFF',
  textMain:      '#1A1207',
  textSub:       '#6B7280',
  border:        '#FDEBD0',
  borderDark:    '#F0C070',
  success:       '#10B981',
  successBg:     '#D1FAE5',
  successText:   '#065F46',
  warning:       '#F59E0B',
  warningBg:     '#FEF3C7',
  warningText:   '#92400E',
  danger:        '#EF4444',
  dangerBg:      '#FEE2E2',
  dangerText:    '#991B1B',
  info:          '#3B82F6',
  infoBg:        '#DBEAFE',
  infoText:      '#1E40AF',
};

export function badge(status) {
  const map = {
    active:    [C.successBg, C.successText],
    paid:      [C.successBg, C.successText],
    delivered: [C.successBg, C.successText],
    pending:   [C.warningBg, C.warningText],
    unpaid:    [C.warningBg, C.warningText],
    shipped:   ['#F3E8FF', '#6D28D9'],
    confirmed: [C.infoBg,   C.infoText],
    inactive:  [C.dangerBg, C.dangerText],
    overdue:   [C.dangerBg, C.dangerText],
    cancelled: [C.dangerBg, C.dangerText],
  };
  const [bg, color] = map[status] || ['#F3F4F6', '#374151'];
  return {
    background: bg, color,
    padding: '3px 10px', borderRadius: '20px',
    fontSize: '11px', fontWeight: 600, textTransform: 'capitalize',
    display: 'inline-block',
  };
}
